
const CreateTextAreaComponent_mutate = `
    mutation createTextareaComponent(
      $label: String!
      $formId: Int!
      $mandatory: Boolean
      $caption: String
      $tooltip: String      
      $maxLength: Int!
      $width: Int!
      $height: Int!
      ) {
      createTextareaComponent(                
        label: $label,
        formId: $formId,
        mandatory: $mandatory,
        caption: $caption,
        tooltip: $tooltip,        
        maxLength: $maxLength,
        width: $width
        height: $height) {
         answer
            {
              answerId
              componentId
              {
                formId
                {
                  name
                  clientId
                  {
                    tenantId
                    {
                      name
                    }
                    name
                  }
                }
                componentId
                label
                mandatory
                caption
                tooltip
                order
              }
              label
              value
              score
              order
              maxLength
              width
              height
            }
                  
      }
    }
`;

const EditTextAreaComponent_mutate = `
  mutation editTextAreaComponent(
    $componentId: Int!
    $label: String 
    $mandatory: Boolean
    $caption: String
    $tooltip: String
    $maxLength: Int
    $width: Int
    $height: Int
    ) {
    editTextarea(
      componentId: $componentId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,
      maxLength: $maxLength,
      width: $width
      height: $height) 
      {
        component {
          componentId
          answerList{
            answerId 
            label
            value
            maxLength
            width
            height
          }
          caption
          tooltip
          order
          label
          mandatory          
        }
      }
    }
`;


module.exports = {  
  
  CREATE_TEXTAREA_COMPONENT_MUTATION : CreateTextAreaComponent_mutate,
  EDIT_TEXTAREA_COMPONENT_MUTATION : EditTextAreaComponent_mutate
  
}
